import { render } from "./ClickerGame.vue?vue&type=template&id=4a11821d"
import script from "./ClickerGame.vue?vue&type=script&lang=js"
export * from "./ClickerGame.vue?vue&type=script&lang=js"

import "./ClickerGame.vue?vue&type=style&index=0&id=4a11821d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__